import React from "react";

const Bash_Ls = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Ls</h2>
      <p>List directory contents. Use options to change the output.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>ls [options] [file...]</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>ls
ls -l
ls -la /path/to/dir</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Tip: use -h for human-readable sizes.</p>
    </div>
  );
};

export default Bash_Ls;
